// ============================================================
// 广发圩 - 常量定义
// ============================================================

import type { TaskCategory, MembershipType } from '../types'

// ─── 任务分类 ───────────────────────────────────────────────

export const TASK_CATEGORY_MAP: Record<TaskCategory, { label: string; icon: string }> = {
  bounty: { label: '悬赏任务', icon: '🏷️' },
  survey: { label: '问卷调查', icon: '📋' },
  design: { label: '设计需求', icon: '🎨' },
  promotion: { label: '推广拉新', icon: '📢' },
  errand: { label: '生活互助', icon: '🏃' },
  tech: { label: '技术开发', icon: '💻' },
  writing: { label: '文案写作', icon: '✍️' },
  other: { label: '其他任务', icon: '📎' },
}

export const TASK_CATEGORIES = Object.entries(TASK_CATEGORY_MAP).map(([value, { label }]) => ({
  value: value as TaskCategory,
  label,
}))

// ─── 会员套餐 ───────────────────────────────────────────────

export const MEMBERSHIP_MAP: Record<Exclude<MembershipType, 'none'>, { label: string; price: number; dailyBonus: number; feeRate: number }> = {
  monthly: { label: '月卡', price: 9.9, dailyBonus: 5, feeRate: 0.08 },
  quarterly: { label: '季卡', price: 25.9, dailyBonus: 8, feeRate: 0.06 },
  yearly: { label: '年卡', price: 89.9, dailyBonus: 15, feeRate: 0.04 },
}

// ─── 签到奖励 ───────────────────────────────────────────────

export const SIGN_IN_REWARDS: Record<number, number> = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 10,
}

// ─── 积分 ───────────────────────────────────────────────────

export const POINT_CONFIG = {
  /** 1元 = 10积分 */
  RECHARGE_RATIO: 10,
  /** 最低悬赏积分 */
  MIN_REWARD: 10,
  /** 默认手续费率 */
  DEFAULT_FEE_RATE: 0.1,
  /** 最低提现积分 */
  MIN_WITHDRAW: 1000,
  /** 提现手续费率 */
  WITHDRAW_FEE_RATE: 0.05,
  /** 积分兑换比例：100积分 = 1元 */
  EXCHANGE_RATIO: 100,
  /** 邀请奖励 */
  INVITE_REWARD: 50,
} as const

// ─── 分页 ───────────────────────────────────────────────────

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
} as const

// ─── 状态标签 ───────────────────────────────────────────────

export const TASK_STATUS_MAP = {
  draft: { label: '草稿', color: 'default' },
  pending: { label: '待审核', color: 'warning' },
  approved: { label: '进行中', color: 'processing' },
  rejected: { label: '已拒绝', color: 'error' },
  submitted: { label: '待验收', color: 'warning' },
  in_progress: { label: '进行中', color: 'processing' },
  completed: { label: '已完成', color: 'success' },
  cancelled: { label: '已取消', color: 'default' },
  expired: { label: '已过期', color: 'default' },
} as const

export const ACCEPTANCE_STATUS_MAP = {
  accepted: { label: '进行中', color: 'processing' },
  submitted: { label: '待验收', color: 'warning' },
  approved: { label: '已通过', color: 'success' },
  rejected: { label: '已拒绝', color: 'error' },
  disputed: { label: '争议中', color: 'error' },
  cancelled: { label: '已取消', color: 'default' },
} as const
